export const stats = {
  general: {
    filter: {
      group_by: {
        title: 'Kelompok',
        value: {
          // day: 'Hari',
          // week: 'Minggu',
          month: 'Bulan',
          country: 'Negara'
        }
      },

      status: {
        title: 'Status'
      },

      country: {
        title: 'Negara'
      },

      number: {
        title: 'Nomor'
      }
    },

    cell: {
      fee: '0 biaya | {count} biaya | {count} biaya'
    },

    field: {
      min_date: 'Tanggal mulai',
      max_date: 'Tanggal berakhir',
      number_count: 'Jumlah Nomor',
      country: 'Negara',
      number: 'Nomor',
      month: 'Bulan',
      average_subscription_fee: 'Rata-rata biaya langganan per nomor dalam periode',
      connection_cost_sum: 'Dibayar untuk menghubungkan nomor selama periode',
      subscription_fee_sum: 'Dibayar untuk biaya langganan selama periode',
      total: 'Total',
    
    }
  },

  detailed: {
    field: {
      payment_sum: 'Dibayar untuk nomor dalam periode',
      current_status: 'Status saat ini',
      subscription_fee_count: 'Jumlah potongan biaya langganan dalam periode',
      last_payment_date: 'Tanggal potongan terakhir',
      total: 'Total {count}'
    },
    tooltip: {
      sum: 'Jumlah semua pembayaran untuk biaya langganan dan untuk menghubungkan nomor.'
    }
  }

};
